import moment from 'moment';
import messages from "../../../locale/messages";
import { inputTextLimit } from "../../../helpers/FieldRestriction";

const validate = values => {

    const errors = {};

    if (!values.phoneNumber || isNaN(values.phoneNumber) || values.phoneNumber.trim() === "") {
        errors.phoneNumber = messages.required;
    }

    if (!values.firstName || values.firstName.toString().trim() === "") {
        errors.firstName = messages.required;
    } else if (values?.firstName?.length > inputTextLimit) {
        errors.firstName = messages.inputTextLimitError;
    }

    if (!values.lastName || values.lastName.toString().trim() === "") {
        errors.lastName = messages.required;
    } else if (values?.lastName?.length > inputTextLimit) {
        errors.lastName = messages.inputTextLimitError;
    }

    if (!values.email) {
        errors.email = messages.emailRequired;
    } else if (!/^(([^<>()[\]\\.,;.!-#$_&%*+/=?:{|}~-\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i.test(values.email)) {
        errors.email = messages.emailInvalid;
    }

    if (!values.categoryId) {
        errors.categoryId = messages.required;
    }

    if (!values.location || !values.location.toString().trim() === "") {
        errors.location = messages.required;
    }

    if (values?.bookingType == 2 && (!values.scheduleFrom || !values.scheduleFrom.toString().trim() === "")) {
        errors.scheduleFrom = messages.required;
    } else if (values?.bookingType == 2 && values.scheduleFrom) {
        let currentTime = moment().add(19, 'minutes'), today = moment();
        if (today > values.scheduleFrom) {
            errors.scheduleFrom = messages.selectPastDate;
        } else if (today < values.scheduleFrom && currentTime > values.scheduleFrom) {
            errors.scheduleFrom = messages.scheduleAheadTime;
        }
    }

    return errors;
}

export default validate;
